import { styled, Box } from "@mui/material";

export const ShareConfigCodeRoot = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 15,
  "@media (orientation: portrait)": {
    width: "100%",
  },
}));
